module.exports = __webpack_public_path__ + "static/img/d.2f59d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/photo_pack/d.png
// module id = VS/d
// module chunks = 12